import { useState } from 'react';
import { getFunctions, httpsCallable } from "firebase/functions";

import app from '../firebase';

export function useInviteUser() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const functions = getFunctions(app, "europe-west3");
  const inviteUser = httpsCallable(functions, "inviteUser");

  const sendInvite = async ({ name, email, role }) => {
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const result = await inviteUser({
        name: String(name || '').trim(),
        email: String(email || '').trim().toLowerCase(),
        role,
      });

      setSuccess(true);
      return result.data;
    } catch (caughtError) {
      const message = caughtError?.message || 'Failed to send invitation.';
      setError(message.replace(/^FirebaseError:\s*/i, '').trim());
      setSuccess(false);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    sendInvite,
    loading,
    error,
    success,
  };
}
